module.exports = "https://coursera_assets.s3.amazonaws.com/images/447126835dcf888bab8af6b976602a12.png";